import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Popover,
  Tooltip,
  Typography,
} from '@mui/material';

const languageOptions = {
  en: {
    icon: '/static/icons/uk_flag.svg',
    label: 'English',
  },
  fr: {
    icon: '/static/icons/fr_flag.svg',
    label: 'français',
  },
  es: {
    icon: '/static/icons/es_flag.svg',
    label: 'Español',
  },
  cn: {
    icon: '/static/icons/cn_flag.svg',
    label: '中文',
  },
};

const LanguagePopover = () => {
  const anchorRef = useRef(null);
  const { i18n, t: translate } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeLanguage = (language) => {
    i18n.changeLanguage(language);
    setOpen(false);
  };

  const selectedOption = languageOptions[i18n.language];

  return (
    <>
      <Tooltip title={translate('Tooltip_Language')}>
        <IconButton onClick={handleOpen} ref={anchorRef}>
          <Box
            sx={{
              display: 'flex',
              height: 20,
              width: 20,
              '& img': {
                width: '100%',
              },
            }}
          >
            <img alt={selectedOption.label} src={selectedOption.icon} />
          </Box>
        </IconButton>
      </Tooltip>
      <Popover
        anchorEl={anchorRef.current}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom',
        }}
        keepMounted
        onClose={handleClose}
        open={open}
        PaperProps={{
          sx: { width: 240 },
        }}
      >
        {Object.keys(languageOptions).map((language) => (
          <MenuItem onClick={() => handleChangeLanguage(language)} key={language}>
            <ListItemIcon>
              <Box
                sx={{
                  display: 'flex',
                  height: 20,
                  width: 20,
                  '& img': {
                    width: '100%',
                  },
                }}
              >
                <img alt={languageOptions[language].label} src={languageOptions[language].icon} />
              </Box>
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography color="textPrimary" variant="subtitle2">
                  {languageOptions[language].label}
                </Typography>
              }
            />
          </MenuItem>
        ))}
      </Popover>
    </>
  );
};

export default LanguagePopover;
